import { StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import "./styles.css";

// The HTML inside #root was server-rendered at build time for this exact
// route by scripts/prerender.mjs. Hydrate on top of it rather than
// re-rendering from scratch, otherwise React discards the SSR markup and
// crawlers plus first-paint users see a flicker.
hydrateRoot(
  document.getElementById("root")!,
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
